import React, { useState } from "react";
import EditMenus from "../../components/EditMenus";
import Headerbuttons from "../../components/Headerbuttons";
import DashboardButtons from "../../components/DashboardButtons";
import OpportunityTabs from "../../components/OpportunityTabs";
import ContactButtons from "../../components/ContactButtons";
import SettingMenu from "../../components/SettingMenu";
import LaunchPad from "../../components/LaunchPad";
import { useParams, useNavigate } from "react-router-dom";
import LogoUpload from "../../components/LogoUpload";

export default function UICustomizationPage() {
  const { type } = useParams();
  const navigate = useNavigate();

  let tabs = [];
  if (type === "agency") {
    tabs = [
      { id: "menu", label: "Edit Menu", content: <EditMenus /> },
      { id: "dashboard", label: "Dashboard Buttons", content: <DashboardButtons /> },
      { id: "header", label: "Header Buttons", content: <Headerbuttons /> },
      { id: "setting_menu", label: "Setting Menu", content: <SettingMenu /> },
    ];
  } else {
    tabs = [
      { id: "menu", label: "Edit Menu", content: <EditMenus /> },
      { id: "dashboard", label: "Dashboard Buttons", content: <DashboardButtons /> },
      { id: "header", label: "Header Buttons", content: <Headerbuttons /> },
      { id: "opportunity", label: "Opportunity Tabs", content: <OpportunityTabs /> },
      { id: "contact", label: "Contact Buttons", content: <ContactButtons /> },
      { id: "setting_menu", label: "Setting Menu", content: <SettingMenu /> },
      { id: "launchPad", label: "LaunchPad", content: <LaunchPad /> },
    ];
  }

  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <div
      className="min-vh-100 bg-white text-dark"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      <main className="container py-4" style={{ maxWidth: 1080 }}>
        {/* Back */}
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="ui-back-btn d-inline-flex align-items-center mb-4 bg-transparent border-0 p-0 text-secondary"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-1">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          <span style={{ fontSize: "0.875rem", fontWeight: 500 }}>Back</span>
        </button>

        {/* Header with Logo */}
        <div className="mb-4">
          <LogoUpload
            hederText={"Customize your organization’s user interface and branding."}
          />
        </div>

        {/* Tabs */}
        <nav className="ui-tabbar mb-4">
          <div className="d-flex flex-nowrap overflow-auto" role="tablist">
            {tabs.map((tab) => {
              const isActive = activeTab.id === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => setActiveTab(tab)}
                  className={`ui-tab bg-transparent border-0 ${isActive ? "is-active" : ""}`}
                >
                  {tab.label}
                </button>
              );
            })}
          </div>
        </nav>

        {/* Tab content */}
        <div className="tab-content">{activeTab.content}</div>
      </main>

      <style>{`
        .ui-back-btn {
          transition: color 0.15s ease, transform 0.15s ease;
        }
        .ui-back-btn:hover {
          color: #1f2937 !important;
        }
        .ui-back-btn:hover svg {
          transform: translateX(-2px);
        }
        .ui-back-btn svg {
          transition: transform 0.15s ease;
        }

        .ui-tabbar {
          border-bottom: 1px solid #ececec;
        }
        .ui-tab {
          position: relative;
          padding: 10px 2px;
          margin-right: 28px;
          font-size: 0.875rem;
          font-weight: 500;
          color: #6b7280;
          white-space: nowrap;
          transition: color 0.15s ease;
        }
        .ui-tab:last-child {
          margin-right: 0;
        }
        .ui-tab:hover {
          color: #1f2937;
        }
        .ui-tab.is-active {
          color: #1f2937;
          font-weight: 600;
        }
        .ui-tab.is-active::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: -1px;
          height: 2px;
          background: #4f46e5;
          border-radius: 2px;
        }
        .ui-tab:focus-visible {
          outline: none;
          color: #1f2937;
          box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12);
          border-radius: 4px;
        }
      `}</style>
    </div>
  );
}
